var map = {
	"./blue/angle/orange-left-bottom.png": "7653",
	"./blue/angle/orange-left-top.png": "8952",
	"./blue/angle/orange-right-bottom.png": "8059",
	"./blue/angle/orange-right-top.png": "10a6",
	"./blue/angle/red-left-bottom.png": "bdfb",
	"./blue/angle/red-left-top.png": "e340",
	"./blue/angle/red-right-bottom.png": "f3b6",
	"./blue/angle/red-right-top.png": "94af",
	"./blue/angle/white-left-bottom.png": "7ea5",
	"./blue/angle/white-left-top.png": "f695",
	"./blue/angle/white-right-bottom.png": "29c3",
	"./blue/angle/white-right-top.png": "306c",
	"./blue/application/back.png": "6e59",
	"./blue/application/close.png": "adb5",
	"./blue/application/danger.png": "2db1",
	"./blue/application/iphone.png": "3c7f",
	"./blue/application/open.png": "36b5",
	"./blue/application/prudence.png": "cafe",
	"./blue/application/sort.png": "fb02",
	"./blue/background.png": "7461",
	"./blue/background0.webm": "10b7",
	"./blue/background1.webm": "a523",
	"./blue/confirm-modal.png": "5572",
	"./blue/crashLog/line.png": "d559",
	"./blue/crashLog/model.png": "d791",
	"./blue/crashLog/os.png": "8f34",
	"./blue/dataAnalysis/drop.png": "571b",
	"./blue/dataAnalysis/rise.png": "7e27",
	"./blue/environment/circle.png": "4eac",
	"./blue/error.png": "bf00",
	"./blue/gaugeBg.png": "1038",
	"./blue/gaugeDottedBg.svg": "2af6",
	"./blue/home01.webm": "083a",
	"./blue/homepiratebk.png": "c1db",
	"./blue/iphone.png": "8ab9",
	"./blue/iphone.webm": "2923",
	"./blue/iphone1.webm": "3209",
	"./blue/item01.webm": "8582",
	"./blue/item02.webm": "de7a",
	"./blue/item03.webm": "d965",
	"./blue/item04.webm": "8221",
	"./blue/item05.webm": "d9f1",
	"./blue/line01.webm": "e4b8",
	"./blue/login-bg.png": "229a",
	"./blue/mapbg.png": "e36d",
	"./blue/nav/appMonitor.png": "5693",
	"./blue/nav/appMonitor1.png": "35d6",
	"./blue/nav/appSafe.png": "d4b6",
	"./blue/nav/appSafe1.png": "4efd",
	"./blue/nav/asset.png": "f26e",
	"./blue/nav/asset1.png": "fb39",
	"./blue/nav/crashLog.png": "8bb7",
	"./blue/nav/crashLog1.png": "c6a3",
	"./blue/nav/data.png": "b1ab",
	"./blue/nav/data1.png": "5c88",
	"./blue/nav/envMonitor.png": "090a",
	"./blue/nav/envMonitor1.png": "e59d",
	"./blue/nav/home.png": "b996",
	"./blue/nav/home1.png": "86e8",
	"./blue/nav/line.png": "b103",
	"./blue/nav/logo.png": "a5a1",
	"./blue/nav/piracy.png": "5482",
	"./blue/nav/piracy1.png": "c399",
	"./blue/nav/riskControl.png": "58f4",
	"./blue/nav/riskControl1.png": "46e9",
	"./blue/nav/screen.png": "c008",
	"./blue/nav/screen1.png": "7eae",
	"./blue/nav/virus.png": "da3f",
	"./blue/nav/virus1.png": "88a0",
	"./blue/safetyindex.webm": "1b6d",
	"./blue/success.png": "dd71",
	"./blue/weather.png": "05f8",
	"./font/Azonix.otf": "9295",
	"./images/activeusers.png": "ac20",
	"./images/andriod.png": "49c4",
	"./images/angle/orange-left-bottom.png": "e4ac",
	"./images/angle/orange-left-top.png": "963a",
	"./images/angle/orange-right-bottom.png": "23db",
	"./images/angle/orange-right-top.png": "2a71",
	"./images/angle/red-left-bottom.png": "c224",
	"./images/angle/red-left-top.png": "1827",
	"./images/angle/red-right-bottom.png": "8b02",
	"./images/angle/red-right-top.png": "a95c",
	"./images/angle/white-left-bottom.png": "0ece",
	"./images/angle/white-left-top.png": "59e2",
	"./images/angle/white-right-bottom.png": "b6da",
	"./images/angle/white-right-top.png": "51ce",
	"./images/animation.png": "32d6",
	"./images/application/back.png": "7d29",
	"./images/application/close.png": "6648",
	"./images/application/danger.png": "0d19",
	"./images/application/iphone.png": "5df7",
	"./images/application/open.png": "c150",
	"./images/application/prudence.png": "bba2",
	"./images/application/sort.png": "7966",
	"./images/background.png": "9855",
	"./images/background0.webm": "bde0",
	"./images/background1.webm": "5e81",
	"./images/circle.png": "ad57",
	"./images/crashLog/line.png": "7df4",
	"./images/crashLog/model.png": "b558e",
	"./images/crashLog/os.png": "1b96",
	"./images/dataAnalysis/drop.png": "4d21",
	"./images/dataAnalysis/rise.png": "9179",
	"./images/down.png": "7c7c",
	"./images/environment/circle.png": "cc51",
	"./images/gaugeBg.png": "0d69",
	"./images/gaugeDottedBg.svg": "4160d",
	"./images/heighrisk.png": "3bd8",
	"./images/home.webm": "750b",
	"./images/home01.webm": "c723",
	"./images/homepiratebk.png": "6022",
	"./images/infection.png": "f208",
	"./images/ios.png": "3160",
	"./images/iphone.png": "eea5",
	"./images/iphone.webm": "7098",
	"./images/item01.webm": "1e3b",
	"./images/item02.webm": "f5e2",
	"./images/item03.webm": "43da",
	"./images/item04.webm": "11c0",
	"./images/item05.webm": "a2bd",
	"./images/largeScreen/countbg1.png": "3d98",
	"./images/largeScreen/countbg2.png": "5eca",
	"./images/largeScreen/countbg3.png": "c75a",
	"./images/largeScreen/high-bg.png": "5ace",
	"./images/largeScreen/high-border.png": "a74e",
	"./images/largeScreen/low-bg.png": "8767",
	"./images/largeScreen/low-border.png": "76c6",
	"./images/largeScreen/middle-bg.png": "1b4d",
	"./images/largeScreen/middle-border.png": "c6cc",
	"./images/largeScreen/phone.png": "1de7",
	"./images/largeScreen/safe-bg.png": "0973",
	"./images/largeScreen/safe-border.png": "1359",
	"./images/largeScreen/vivo.png": "fb20",
	"./images/largeScreen/vivo1.png": "2891",
	"./images/largeScreen/vivo2.png": "ee51",
	"./images/line.webm": "d244",
	"./images/line01.webm": "1ec3",
	"./images/login-bg.png": "e642",
	"./images/nav/appMonitor.png": "1d15",
	"./images/nav/appMonitor1.png": "37e6",
	"./images/nav/crashLog.png": "bb2f",
	"./images/nav/crashLog1.png": "a9dc",
	"./images/nav/data.png": "dc9d",
	"./images/nav/data1.png": "d542",
	"./images/nav/envMonitor.png": "3f49",
	"./images/nav/envMonitor1.png": "0e46",
	"./images/nav/home.png": "8034",
	"./images/nav/home1.png": "8b48",
	"./images/nav/line.png": "de8e",
	"./images/nav/logo.png": "a313",
	"./images/nav/piracy.png": "4eda",
	"./images/nav/piracy1.png": "b8c8",
	"./images/nav/riskControl.png": "ab3d",
	"./images/nav/riskControl1.png": "b42a",
	"./images/nav/virus.png": "4664",
	"./images/nav/virus1.png": "38e8",
	"./images/piracy.png": "8ed0",
	"./images/safeNum.png": "19c4",
	"./images/safetyindex.webm": "0ced",
	"./images/up.png": "9b31",
	"./images/virus.png": "f6b3",
	"./images/weather.png": "63e6",
	"./logo.png": "cf05",
	"./orange/activeusers.png": "77e0",
	"./orange/angle/orange-left-bottom.png": "e89f",
	"./orange/angle/orange-left-top.png": "7675",
	"./orange/angle/orange-right-bottom.png": "653e",
	"./orange/angle/orange-right-top.png": "93b9",
	"./orange/angle/red-left-bottom.png": "a8f3",
	"./orange/angle/red-left-top.png": "bcef",
	"./orange/angle/red-right-bottom.png": "be0e",
	"./orange/angle/red-right-top.png": "3574",
	"./orange/angle/white-left-bottom.png": "6fa2",
	"./orange/angle/white-left-top.png": "590b",
	"./orange/angle/white-right-bottom.png": "500b",
	"./orange/angle/white-right-top.png": "8a0b",
	"./orange/animation.png": "a2bf",
	"./orange/application/back.png": "9b6d",
	"./orange/application/close.png": "89f2",
	"./orange/application/danger.png": "485f",
	"./orange/application/iphone.png": "5db2",
	"./orange/application/open.png": "dcaf",
	"./orange/application/prudence.png": "8f54",
	"./orange/application/sort.png": "d8ee",
	"./orange/background.png": "93b8",
	"./orange/background0.webm": "bb74",
	"./orange/background1.webm": "ea9a",
	"./orange/circle.png": "40a9",
	"./orange/confirm-modal.png": "5b15",
	"./orange/crashLog/line.png": "33ee",
	"./orange/crashLog/model.png": "1cdc7",
	"./orange/crashLog/os.png": "6748",
	"./orange/dataAnalysis/drop.png": "517f",
	"./orange/dataAnalysis/rise.png": "d186",
	"./orange/environment/circle.png": "5bce",
	"./orange/error.png": "076c",
	"./orange/gaugeBg.png": "241f",
	"./orange/gaugeDottedBg.svg": "9910",
	"./orange/heighrisk.png": "c4a3",
	"./orange/home.webm": "27f5",
	"./orange/home01.webm": "ebd1",
	"./orange/homepiratebk.png": "9865",
	"./orange/infection.png": "c107",
	"./orange/iphone.png": "adcf",
	"./orange/iphone.webm": "3c9a",
	"./orange/item01.webm": "8590",
	"./orange/item02.webm": "7081",
	"./orange/item03.webm": "8b1e",
	"./orange/item04.webm": "b59f",
	"./orange/item05.webm": "2c9e",
	"./orange/line.webm": "653c",
	"./orange/line01.webm": "44ec",
	"./orange/login-bg.png": "4939",
	"./orange/mapbg.png": "2eb3",
	"./orange/nav/appMonitor.png": "bce8",
	"./orange/nav/appMonitor1.png": "f9d0",
	"./orange/nav/appSafe.png": "6517",
	"./orange/nav/appSafe1.png": "cb9f",
	"./orange/nav/asset.png": "8188",
	"./orange/nav/asset1.png": "2656",
	"./orange/nav/crashLog.png": "25e7",
	"./orange/nav/crashLog1.png": "5960",
	"./orange/nav/data.png": "dd3d",
	"./orange/nav/data1.png": "2d4f",
	"./orange/nav/envMonitor.png": "34b3",
	"./orange/nav/envMonitor1.png": "2b5d",
	"./orange/nav/home.png": "e0dc",
	"./orange/nav/home1.png": "c41b",
	"./orange/nav/line.png": "b556",
	"./orange/nav/logo.png": "0932",
	"./orange/nav/piracy.png": "12b6",
	"./orange/nav/piracy1.png": "483d",
	"./orange/nav/riskControl.png": "0ec4",
	"./orange/nav/riskControl1.png": "4c93",
	"./orange/nav/virus.png": "d898",
	"./orange/nav/virus1.png": "87c6",
	"./orange/piracy.png": "aad0",
	"./orange/safetyindex.webm": "0812",
	"./orange/success.png": "7a4f",
	"./orange/virus.png": "2f58",
	"./orange/weather.png": "5f10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";